import React from 'react';
import { formatMessage } from '../../../../../../Localization/formatMessage';
import Messages from '../../../../../../Localization/Messages';
import { PresentationMode } from '../../../../../../Enums/PresentationMode';
import { copyCostCentersFormId } from '../CopyCostCenters';
import { useNavigate } from 'react-router-dom';
import { teamPageReducerTypes } from '../../../../Reducer';
import { useTeamPageContext } from '../../../../TeamPage';
import ModalPrimaryButton from '../../../../../../Elements/ids/Buttons/ModalPrimaryButton';
import SecondaryButton from '../../../../../../Elements/ids/Buttons/SecondaryButton';
import PrimaryButton from '../../../../../../Elements/ids/Buttons/PrimaryButton';

const CopyCostCentersButtons = ({ closeView, canSubmit, modalMode, closeError, newTeamData, newTeamCodePrefix }) => {
  const navigate = useNavigate();
  const { teamPageDispatch } = useTeamPageContext();

  const goToNewlyCreatedTeamPage = codePrefix => {
    navigate(`/team/view/${codePrefix}`);
  };

  return (
    <>
      <SecondaryButton onClickEvent={closeView} text={formatMessage(Messages.common_cancel)} />

      {newTeamData.isCreated && (
        <PrimaryButton
          text={formatMessage(Messages.copyCostCenters_navigateToNewTeam)}
          onClickEvent={() => {
            goToNewlyCreatedTeamPage(newTeamCodePrefix);
            closeView();
            teamPageDispatch({
              type: teamPageReducerTypes.updateTeamInfo,
              payload: newTeamData.team,
            });
          }}
        />
      )}

      {modalMode === PresentationMode.Error && (
        <PrimaryButton text={formatMessage(Messages.common_ok)} onClickEvent={closeError} />
      )}

      {modalMode !== PresentationMode.Error && !newTeamData.isCreated && (
        <ModalPrimaryButton
          text={formatMessage(Messages.copyCostCenters_create)}
          canSubmit={canSubmit}
          formId={copyCostCentersFormId}
        />
      )}
    </>
  );
};

export default CopyCostCentersButtons;
